export default class CollectionGenerators {
    static *clone(collection, startIndex = 0, endIndex) {
        for (let i = startIndex; i < (endIndex !== null && endIndex !== void 0 ? endIndex : collection.length - 1); i++) {
            yield collection.get(i);
        }
    }
    static *replaceWith(oldElements, newElements, keySelector, onReplace) {
        for (const newElement of newElements) {
            const elementKey = keySelector(newElement);
            const oldElement = oldElements.singleOrDefault(e => keySelector(e) == elementKey);
            if (onReplace) {
                onReplace(newElement, oldElement);
            }
            yield newElement;
        }
    }
    static *reversed(collection) {
        for (let i = collection.length - 1; i >= 0; i--) {
            yield collection.get(i);
        }
    }
}
//# sourceMappingURL=CollectionGenerators.js.map